import { Component, OnInit } from '@angular/core';
import { ContribuicaoService } from 'src/app/services/contribuicao.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
    selector: 'app-contribuicao',
    templateUrl: './contribuicao.component.html',
    styleUrls: ['./contribuicao.component.css'],
    imports: [ReactiveFormsModule, CommonModule, NgxMaskDirective]
})
export class ContribuicaoComponent implements OnInit {

  modalStep: string = "contrib_1";
  valorAtual: number;
  valorMinimo: number = 0;
  formContrib: FormGroup = null;  
  
  msgErro: string = "";
  loading: boolean = false;

  constructor(private contibuicao:ContribuicaoService, private toastr: ToastrService) {
    this.formContrib = new FormGroup({
      valor:new FormControl(null,[Validators.required]),
      assinatura: new FormControl(null,[Validators.required])
    });
   }

  ngOnInit() {
    this.buscaValorContribuicao();
  }

  public buscaValorContribuicao(){
     
    this.contibuicao
    .buscaValorContribuicao()
    .subscribe(
      (res:any)=>{
        this.valorAtual = res.valorAtual;
        this.valorMinimo = res.valorMinimo;
      }
    )
  }

  salvarAlteracao(): boolean {

    let valor = this.formContrib.get("valor").value;

    if(valor < this.valorMinimo){
      alert("O valor mínimo é " + this.valorMinimo.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}));
      this.formContrib.get("valor").setValue("");
      return false;
    
    }

    this.loading = true;

    this.contibuicao
    .alterarContribuicao(this.formContrib.getRawValue())
    .pipe(
      finalize(() => { this.loading=false })
    )
    .subscribe(
      (res:any)=>{
        this.modalStep = 'contrib_2';
      },
      (error: HttpErrorResponse) => {
        this.toastr.error(error.error.ex);
      }
    )

    return true;
  }

}
